// Human-readable times for the Operator screens, on the portal's moment.
import moment from "moment";

/** "Today, 3:30 PM" / "Yesterday, 9:02 AM" / "Oct 3, 3:30 PM" / "Oct 3, 2025, 3:30 PM". */
export const formatWhen = (date) => {
  if (!date) return "";
  const m = moment(date);
  const now = moment();
  if (m.isSame(now, "day")) return `Today, ${m.format("h:mm A")}`;
  if (m.isSame(now.clone().subtract(1, "day"), "day")) return `Yesterday, ${m.format("h:mm A")}`;
  if (m.isSame(now, "year")) return m.format("MMM D, h:mm A");
  return m.format("MMM D, YYYY, h:mm A");
};

/** Day label for timeline rows: "Today" / "Yesterday" / "Oct 3". */
export const formatDay = (date) => {
  if (!date) return "";
  const m = moment(date);
  const now = moment();
  if (m.isSame(now, "day")) return "Today";
  if (m.isSame(now.clone().subtract(1, "day"), "day")) return "Yesterday";
  return m.isSame(now, "year") ? m.format("MMM D") : m.format("MMM D, YYYY");
};

/** Clock with seconds for timeline rows: "3:30:12 PM". */
export const formatClock = (date) => (date ? moment(date).format("h:mm:ss A") : "");

/** "5 minutes ago", with the full date for a tooltip. */
export const formatAgo = (date) => (date ? moment(date).fromNow() : "");
export const formatFull = (date) => (date ? moment(date).format("MMM D, YYYY, h:mm:ss A") : "");
